import firebaseApp from "../../firebase/credenciales";
import { getFirestore, collection, getDocs} from "firebase/firestore";
const db = getFirestore(firebaseApp);

    

export default async function getbotones_Bancos() {
    const BotonesDB =  [];
    console.log("Bancos");
    const collectionRef = collection(db, "Bancos/Botones/Productos/");
    const snapshot = await getDocs(collectionRef);
    snapshot.forEach((doc) => {
      BotonesDB.push(doc.data());
    });
    return BotonesDB;
}